
// import Carrousel from '../../components/corousel/carousel';
import Footer from '../../components/footer';
import Links from './links/links';
import NavBar from '../../components/navBar';
import CarousselNoticias from './noticias/carousselNoticias';
import Servicos from './services';
import Slider from './slider/slider';
import Calendar from '../../admin/gestAgenda/calendario/calendar';
import CarousselDestaques from './destaques/carousselDestaques';
import RegisterAccess from '../../utils/registerAccess';
import FormCreateReclamacao from '../../admin/gestReclamacoes/utente/formCreateReclamacao';
import HomeArtigos from './artigosCientifico/listArtigos/artigosCientifico';
import ExpedienteForm from '../expediente/expedienteForm';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../services/api';
import { useEffect } from 'react';

function Home() {
    const definicoesSistema = useSelector((state) => state.definicoesSistema.data);
    const dispatch = useDispatch();

    useEffect(() => {

        api.get(`/definicoes/sistema/all`)
            .then(response => {
                // console.log(response)
                dispatch({
                    type: 'definicoesSistema',
                    payload: {
                        definicoesSistema: response.data.definicoesSistema[0],
                    },
                });
            }).catch(err => '')
    }, [dispatch])

    const IsHabilited = ({ definicao, children }) => {
        const isBilited = definicoesSistema?.seccoes.includes(definicao);

        return isBilited ? <>{children}</> : null;
    };

    return (
        <main>
            <RegisterAccess page={'pagina inicial'} />

            <NavBar />

            <Slider />

            {/* Modal de formulario de Expediente */}
            <ExpedienteForm />

            {/* <IsHabilited definicao={'servicos'}> */}
            <Servicos definicoesSistema={definicoesSistema} />
            {/* </IsHabilited> */}

            <IsHabilited definicao={'agenda'}>
                <Calendar />
            </IsHabilited>


            <IsHabilited definicao={'noticias'}>
                <CarousselNoticias />
            </IsHabilited>


            <IsHabilited definicao={'destaques'}>
                <CarousselDestaques definicoesSistema={definicoesSistema} />
            </IsHabilited>


            <IsHabilited definicao={'artigos'}>
                <HomeArtigos />
            </IsHabilited>


            {/* // Verificar se a seção de reclamação está nas definiceoes de habilitacao */}
            {/* Modal de formulario de reclamacoes */}
            <IsHabilited definicao={'reclamacao'}>
                <FormCreateReclamacao />
            </IsHabilited>


            <IsHabilited definicao={'links'}>
                <Links />
            </IsHabilited>

            <Footer />
        </main>

    );
}

export default Home;
